import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'

const FormInputDate = ({
    color = 'primary',
    control,
    disabled = false,
    inputProps = {},
    label = '',
    name,
    onHandleChange = null,
    placeholder = 'Select a date',
    rules = {},
    shouldUnregister = false,
    size = 'medium',
    sx = {},

    variant = 'outlined',
}) => {
    const { t } = useTranslation()

    const userTimeZone = dayjs.tz.guess()

    return (
        <Controller
            control={control}
            disabled={disabled}
            key={name}
            name={name}
            render={({ field: { onChange, ref, value } }) => (
                <DatePicker
                    closeOnSelect={false}
                    disabled={disabled}
                    disableOpenPicker={disabled}
                    format="DD-MMM-YYYY"
                    label={label}
                    slotProps={{
                        textField: {
                            size: size,
                            inputRef: ref,
                            sx: [sx, ...(Array.isArray(sx) ? sx : [sx])],
                            color: color,
                            placeholder: t(placeholder),
                            variant: variant,
                            inputProps,
                            InputProps: {
                                disableUnderline: disabled,
                            },
                            InputLabelProps: {
                                shrink: true,
                            },
                        },
                        field: {
                            readOnly: true,
                        },
                        actionBar: {
                            actions: ['clear', 'cancel', 'accept'],
                            disableSpacing: true,
                        },
                    }}
                    timezone={userTimeZone}
                    value={value ? dayjs(value) : null}
                    disablePast
                    onAccept={(date) => {
                        if (onHandleChange && typeof onHandleChange === 'function') {
                            onHandleChange(date?.utc().format() ?? null)
                        }
                        onChange(date?.utc().format() ?? null)
                    }}
                />
            )}
            rules={rules}
            shouldUnregister={shouldUnregister}
        />
    )
}

FormInputDate.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    inputProps: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    rules: PropTypes.object,
    shouldUnregister: PropTypes.bool,
    size: PropTypes.string,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
    variant: PropTypes.string,
    onHandleChange: PropTypes.func,
}

export default FormInputDate
